export default __webpack_public_path__ + "static/media/inter-bold.3c747ac4.woff2";